module.exports = __webpack_public_path__ + "static/media/silence_100s.87372b3b.mp3";